// the HTTP header name we expect to contain the user id
export const HMIS_SESSION_UID_HEADER = 'X-app-user-id';
// JWT arm only: the forwarded token's remaining seconds (Hmis::BaseController#set_app_user_header)
export const HMIS_SESSION_REMAINING_HEADER = 'X-app-session-remaining-secs';
// event fired by request handler for HMIS_SESSION_UID_HEADER
export const HMIS_REMOTE_SESSION_UID_EVENT = 'HmisRemoteSessionUserId';
// event fired to update the application
export const HMIS_APP_SESSION_UID_EVENT = 'HmisAppSessionUserId';
// event fired when a response carries a terminal account error (accountError / 403 type)
export const HMIS_ACCOUNT_ERROR_EVENT = 'HmisAccountError';
